export const environment = {
    development: true,
    VERSION: "0.0.101",
    API_DEFINITION_URL: 'https://dev-spriced-nrp.alpha.simadvisory.com/api/v1/definition',
    API_DATA_URL: 'https://dev-spriced-nrp.alpha.simadvisory.com/api/v1/data-api',
    API_FLINK_URL:'https://dev-spriced-nrp.alpha.simadvisory.com/api/v1/flink/platform',
    URL: 'https://excelplugin.spriced.dev-spriced-nrp.alpha.simadvisory.com',
    AUTH_URL: 'https://auth.alpha.simadvisory.com',
    CLIENT: "D_SPRICED_Client",
    REALMS: "D_SPRICED",
    SERVER_PROCESSING_RECORDS_PER_MINUTE: 900,
    PAGESIZE: 10000,
    PUBLISHRECORD: 1000,
    TOTALELEMENTS: 15000,
    VALIDATIONPOPUPLENGTH: 10000,
    RECORD_LIMIT: 50,
    IDP_HINT: 'saml_spriced_uat',
    appUrl: 'https://excelplugin.spriced.dev-spriced-nrp.alpha.simadvisory.com',
    NX_EXCEL_SERVICE_URL:'https://dev-spriced-nrp.alpha.simadvisory.com/api/v1/excel_service/write-csv',
    NX_TML_URL: 'https://dev-spriced-nrp.alpha.simadvisory.com/api/v1/tml'
 };
